import {
  SERVICE_LIST_REQUEST,
  SERVICE_LIST_SUCCESS,
  SERVICE_LIST_FAIL,
  SERVICE_LIST_RESET,
  POST_SERVICE_REQUEST,
  POST_SERVICE_SUCCESS,
  POST_SERVICE_FAIL,
  POST_SERVICE_RESET,
  UPDATE_SERVICE_REQUEST,
  UPDATE_SERVICE_SUCCESS,
  UPDATE_SERVICE_FAIL,
  UPDATE_SERVICE_RESET,
  DELETE_SERVICE_REQUEST,
  DELETE_SERVICE_SUCCESS,
  DELETE_SERVICE_FAIL,
  DELETE_SERVICE_RESET,
} from "constants/serviceConstants";

export const listServicesReducer = (state = { servicesList: [] }, action) => {
  switch (action.type) {
    case SERVICE_LIST_REQUEST:
      return { loading: true };
    case SERVICE_LIST_SUCCESS:
      return { loading: false, servicesList: action.payload };
    case SERVICE_LIST_FAIL:
      return { loading: false, error: action.payload };
    case SERVICE_LIST_RESET:
      return [];
    default:
      return state;
  }
};

export const servicePostReducer = (state = { service: {} }, action) => {
  switch (action.type) {
    case POST_SERVICE_REQUEST:
      return { loading: true };
    case POST_SERVICE_SUCCESS:
      return { loading: false, service: action.payload };
    case POST_SERVICE_FAIL:
      return { loading: false, error: action.payload };
    case POST_SERVICE_RESET:
      return { service: {} };
    default:
      return state;
  }
};

export const updateServiceReducer = (state = { serviceUpdate: {} }, action) => {
  switch (action.type) {
    case UPDATE_SERVICE_REQUEST:
      return { loading: true };
    case UPDATE_SERVICE_SUCCESS:
      return { loading: false, serviceUpdate: action.payload, success: true };
    case UPDATE_SERVICE_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_SERVICE_RESET:
      return { serviceUpdate: {} };
    default:
      return state;
  }
};

export const deleteServiceReducer = (state = { deleteService: {} }, action) => {
  switch (action.type) {
    case DELETE_SERVICE_REQUEST:
      return { loading: true };
    case DELETE_SERVICE_SUCCESS:
      return { loading: false, deleteService: action.payload, success: true };
    case DELETE_SERVICE_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_SERVICE_RESET:
      return { deleteService: {} };
    default:
      return state;
  }
};
